import { combineReducers } from '@reduxjs/toolkit';
import {
  accountDefaultState,
  accountReducer,
  AccountState,
} from '@slices/account';
import { authDefaultState, authReducer, AuthState } from '@slices/auth';
import {
  paymentsDefaultState,
  paymentsReducer,
  PaymentsState,
} from '@slices/payments';
import { photosDefaultState, photosReducer, PhotosState } from '@slices/photos';
import {
  projectsDefaultState,
  projectsReducer,
  ProjectsState,
} from '@slices/projects';
import { usersDefaultState, usersReducer, UsersState } from '@slices/users';
import {
  withdrawalsDefaultState,
  withdrawalsReducer,
  WithdrawalsState,
} from '@slices/withdrawals';

import { APP_RESET_STORE } from '@actions/action-types';
import { AppAction } from '@actions/app';

export type AppState = {
  account: AccountState;
  auth: AuthState;
  payments: PaymentsState;
  projects: ProjectsState;
  users: UsersState;
  withdrawals: WithdrawalsState;
  photos: PhotosState;
};

export const appDefaultState = {
  account: accountDefaultState,
  auth: authDefaultState,
  payments: paymentsDefaultState,
  projects: projectsDefaultState,
  users: usersDefaultState,
  withdrawals: withdrawalsDefaultState,
  photos: photosDefaultState,
};

export const appReducer = (
  state = appDefaultState,
  action: AppAction
): AppState => {
  if (action.type === APP_RESET_STORE) {
    return appDefaultState;
  }

  return combineReducers({
    account: accountReducer,
    auth: authReducer,
    payments: paymentsReducer,
    projects: projectsReducer,
    users: usersReducer,
    withdrawals: withdrawalsReducer,
    photos: photosReducer,
  })(state, action);
};
